export function normalizeProductCode(code, canonicalDigits = 7) {
  if (code === null || code === undefined) return '';

  const digitsOnly = String(code)
    .match(/\d+/g)
    ?.join('') || '';

  if (!digitsOnly) return '';

  // Convert to number to strip any “extra leading zeros” (e.g. 00000054 -> 54)
  const n = parseInt(digitsOnly, 10);
  if (Number.isNaN(n)) return '';

  return String(n).padStart(canonicalDigits, '0');
}

export function isProductActive(product) {
  if (!product || typeof product !== 'object') return false;
  const state = String(product.state || '').toUpperCase();

  // Billing-API schema keeps both `state` and `inactive` in sync.
  if (state === 'ACTIF') return true;
  if (product.inactive === false) return true;
  return false;
}

export function dedupeProductsByNormalizedCodePreferActive(products, canonicalDigits = 7) {
  const byNorm = new Map();

  (products || []).forEach((product) => {
    const norm = normalizeProductCode(product?.code, canonicalDigits);
    if (!norm) return;

    if (!byNorm.has(norm)) {
      byNorm.set(norm, product);
      return;
    }

    const current = byNorm.get(norm);
    const currentActive = isProductActive(current);
    const incomingActive = isProductActive(product);

    // Prefer ACTIF record when both represent the same numeric code
    if (incomingActive && !currentActive) {
      byNorm.set(norm, product);
    }
  });

  // Sort deterministically by normalized code
  return Array.from(byNorm.values()).sort((a, b) => {
    const na = normalizeProductCode(a?.code, canonicalDigits);
    const nb = normalizeProductCode(b?.code, canonicalDigits);
    return na.localeCompare(nb, 'fr');
  });
}

export function getPreferredAccountByNormalizedCode(products, canonicalDigits = 7) {
  const deduped = dedupeProductsByNormalizedCodePreferActive(products, canonicalDigits);
  const map = new Map();
  deduped.forEach((p) => {
    const norm = normalizeProductCode(p?.code, canonicalDigits);
    if (!norm) return;
    map.set(norm, p?.account || p?.accountingCode || '');
  });
  return map;
}

